<template>
  <div class="settings-instruction container">
    <v-flex>
      <v-switch
        label="Killer feature enabled"
        v-model="isKillerFeatureEnabled"
      />
    </v-flex>
    <div v-if="isKillerFeatureEnabled">
      <h2 class="headline">Killer feature description on Packages</h2>
      <v-form class="form" ref="formKillerFeature">
        <v-card width="320">
          <div class="grey lighten-2">
            <v-card-media height="130" :src="galleryImage"/>
          </div>
          <v-card-title><h3>Image on packages</h3></v-card-title>
          <v-card-actions>
            <v-btn flat color="success" @click="toggleModal">Choose</v-btn>
            <v-btn flat color="error"
                   :disabled="!formData.galleryItemId"
                   @click="resetImage">Reset
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-layout row>
          <v-flex xs12>
            <content-field
              label="Enter title"
              v-model="formData.title"
              :error="$v.formData.title"
            />
            <content-field
              label="Enter first subtitle"
              v-model="formData.descriptions.firstColumn.subtitle"
              :error="$v.formData.descriptions.firstColumn.subtitle"
            />
            <content-field
              label="Enter first description"
              v-model="formData.descriptions.firstColumn.description"
              :error="$v.formData.descriptions.firstColumn.description"
            />
            <content-field
              label="Enter second subtitle"
              v-model="formData.descriptions.secondColumn.subtitle"
              :error="$v.formData.descriptions.secondColumn.subtitle"
            />
            <content-field
              label="Enter second description"
              v-model="formData.descriptions.secondColumn.description"
              :error="$v.formData.descriptions.secondColumn.description"
            />
            <content-field
              label="Enter third subtitle"
              v-model="formData.descriptions.thirdColumn.subtitle"
              :error="$v.formData.descriptions.thirdColumn.subtitle"
            />
            <content-field
              label="Enter third description"
              v-model="formData.descriptions.thirdColumn.description"
              :error="$v.formData.descriptions.thirdColumn.description"
            />
          </v-flex>
        </v-layout>
      </v-form>
    </div>
    <div>
      <v-dialog v-model="modalGallery">
        <galleries-list :modalView="true" @pickedImage="setImage"/>
      </v-dialog>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'
  import GalleriesList from '@/components/pages/Gallery/GalleriesList'
  import { pathOr, clone, assocPath } from 'ramda'

  export default {
    name: 'page-settings',
    mixins: [mixins.isWriteAvailable],
    components: {
      GalleriesList
    },
    props: {
      data: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        formData: null,
        galleryImage: null,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'speakers:write',
        modalGallery: false,
        isKillerFeatureEnabled: false,
        defaultFormData: {
          title: '',
          galleryItemId: null,
          descriptions: {
            firstColumn: {
              subtitle: '',
              description: ''
            },
            secondColumn: {
              subtitle: '',
              description: ''
            },
            thirdColumn: {
              subtitle: '',
              description: ''
            }
          },
          metadataObject: {}
        }
      }
    },
    validations () {
      const data = {
        formData: {
          title: { required },
          descriptions: {
            firstColumn: {
              subtitle: { required },
              description: { required }
            },
            secondColumn: {
              subtitle: { required },
              description: { required }
            },
            thirdColumn: {
              subtitle: { required },
              description: { required }
            }
          },
          galleryItemId: { required }
        }
      }
      if (this.isKillerFeatureEnabled) return data
    },
    watch: {
      isKillerFeatureEnabled(val) {
          if (val) {
            this.setFormData()
          } else {
            this.formData = null
          }
      }
    },
    computed: {
      ...mapGetters([
        'getImgUrl'
      ])
    },
    methods: {
      ...mapActions([
        'setImageUrl',
        'editKillerFeatureData'
      ]),
      toggleModal () {
        this.modalGallery = !this.modalGallery
      },
      resetImage () {
        this.formData.galleryItemId = null
        this.galleryImage = ''
      },
      setImage (item) {
        this.formData.galleryItemId = item.id
        this.galleryImage = item.imagesUrls.originalImageUrl
        this.toggleModal()
      },
      setFormData () {
        this.formData = clone(this.defaultFormData)
        if (!this.data) return
        this.formData.galleryItemId = pathOr(null, ['galleryItemId'], this.data)
        this.formData.title = pathOr('', ['title'], this.data)
        this.formData.descriptions.firstColumn.subtitle = pathOr('', ['descriptions', 'firstColumn', 'subtitle'], this.data)
        this.formData.descriptions.firstColumn.description = pathOr('', ['descriptions', 'firstColumn', 'description'], this.data)
        this.formData.descriptions.secondColumn.subtitle = pathOr('', ['descriptions', 'secondColumn', 'subtitle'], this.data)
        this.formData.descriptions.secondColumn.description = pathOr('', ['descriptions', 'secondColumn', 'description'], this.data)
        this.formData.descriptions.thirdColumn.subtitle = pathOr('', ['descriptions', 'thirdColumn', 'subtitle'], this.data)
        this.formData.descriptions.thirdColumn.description = pathOr('', ['descriptions', 'thirdColumn', 'description'], this.data)
        if (this.formData.galleryItemId) this.takeImage()
      },
      async takeImage () {
        try {
          await this.setImageUrl(this.formData.galleryItemId)
          this.galleryImage = this.getImgUrl
        } catch (err) {
          console.error(err)
        }
      },
      submitForm () {
        if (this.isKillerFeatureEnabled) {
          this.$v.formData.$touch()
          if (this.$v.formData.$invalid) return false
        }
        return assocPath(['metadataObject', 'isKillerFeatureEnabled'], this.isKillerFeatureEnabled, this.formData)
      }
    },
    created () {
      this.setFormData()
    },
    beforeMount () {
      this.isKillerFeatureEnabled = pathOr(false, ['metadataObject', 'isKillerFeatureEnabled'], this.data)
    }
  }
</script>

<style lang="scss" scoped>
  .input,
  .headline {
    width: 100%;
  }

  .input:first-child {
    margin-right: 40px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin: 5px auto 15px;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Packages/killerFeature.vue